import { useCallback } from "react";

// Wrap a given `onError` to also produce a console.error
export default function useErrorReportingCallback(componentName, onError, onCompleteFailure) {
  return useCallback(error => {
    // Report player errors in the console
    console.error(`eden-video-player/${componentName} reported the following error:`, error);
    if (typeof onError === "function") {
      onError(error);
    }
    if (error === "Could not find an error-free player.") {
      onCompleteFailure === null || onCompleteFailure === void 0 ? void 0 : onCompleteFailure();
    }
  }, [onError, onCompleteFailure, componentName]);
}